import React from 'react';

const Loading = () => (
	<i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
)

export default Loading;